import React from 'react'
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { textSubmissionDrawerActions } from '../../../../../store/slices/text-submission-drawer.slice'
import { useDispatch, useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../store/selectors/text-submission-drawer.selectors'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../utils/parseURL.helper'

const CollapseAllQuestionsButton = () => {
    const expandedQuestionIds = useSelector(textSubmissionDrawerSelectors.expandedQuestionIds)
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()

    const { data: questions, isFetching: isFetchingQuestions } = useFetchQuestionsQuery({
        token,
        versionId,
    })

    const allQuestionsExpanded = expandedQuestionIds.length === questions?.length
    const handleSwitchAllQuestionsCollapse = () => {
        if (allQuestionsExpanded) {
            dispatch(textSubmissionDrawerActions.setExpandedQuestionIds([]))
        } else {
            dispatch(textSubmissionDrawerActions.setExpandedQuestionIds(questions.map(question => question.id)))
        }
    }

    return (
        <Button
            onClick={handleSwitchAllQuestionsCollapse}
            icon={allQuestionsExpanded ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
            disabled={isFetchingQuestions}
        >
            {allQuestionsExpanded ? 'Collapse All' : 'Expand All'}
        </Button>
    )
}

export default CollapseAllQuestionsButton
